/**
 * Service Worker registration
 *
 * Registers /service-worker.js in production only.
 * Notifies the user with a sonner toast when a new SW is available.
 */
import { Workbox } from "workbox-window";
import { toast } from "sonner";

export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  // Wait for window load to avoid competing with critical resources
  window.addEventListener("load", () => {
    const wb = new Workbox("/service-worker.js");

    wb.addEventListener("waiting", () => {
      toast("Nuova versione disponibile", {
        description: "Tocca per aggiornare",
        duration: 8000,
        action: {
          label: "Aggiorna",
          onClick: () => {
            wb.addEventListener("controlling", () => {
              window.location.reload();
            });
            wb.messageSkipWaiting();
          },
        },
      });
    });

    wb.addEventListener("activated", (event) => {
      if (!event.isUpdate) {
        // First install
        // eslint-disable-next-line no-console
        console.log("[QrTourist] PWA installata, contenuti pronti per offline");
      }
    });

    wb.register().catch((err) => {
      // eslint-disable-next-line no-console
      console.warn("[QrTourist] SW registration failed:", err);
    });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister()).catch(() => {});
  }
}
